import styles from "../../pages/Community/CreateCommunityPage.module.css";

const CommunityBasicInfo = ({
  communityName,
  setCommunityName,
  themeColor,
  setThemeColor,
  hasLiveSession,
  setHasLiveSession,
  isSubmitting,
}) => {
  return (
    <>
      {/* Community name */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>Community Name</label>
        <input
          type="text"
          value={communityName}
          onChange={(e) => setCommunityName(e.target.value)}
          className={styles.textInput}
          disabled={isSubmitting}
        />
      </div>

      {/* Community Theme */}
      <div className={styles.rowInputGroup}>
        <label className={styles.inlineLabel}>Community theme</label>
        <div className={styles.colorPickerWrapper}>
          <input
            type="color"
            value={themeColor}
            onChange={(e) => setThemeColor(e.target.value)}
            className={styles.colorInput}
            disabled={isSubmitting}
          />
        </div>
      </div>

      {/* Live Sessions */}
      <div className={styles.liveSessionRow}>
        <label className={styles.inlineLabel}>Includes Live Sessions</label>

        <div className={styles.toggleWrapper}>
          <button
            className={`${styles.toggleOption} ${
              hasLiveSession ? styles.activeToggle : ""
            }`}
            onClick={() => setHasLiveSession(true)}
            disabled={isSubmitting}
          >
            Yes
          </button>
          <button
            className={`${styles.toggleOption} ${
              !hasLiveSession ? styles.activeToggle : ""
            }`}
            onClick={() => setHasLiveSession(false)}
            disabled={isSubmitting}
          >
            No
          </button>
        </div>
        <span className={styles.note}>
          <span className={styles.noteHighlight}>NB*</span>: This option will
          create a new section page for
          <br />
          live sessions in this community
        </span>
      </div>
    </>
  );
};

export default CommunityBasicInfo;
